import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../main/header/header.component';

@Component({
  selector: 'app-regulamin',
  standalone: true,
  imports: [CommonModule, HeaderComponent],
  templateUrl: './regulamin.component.html',
  styleUrl: './regulamin.component.scss'
})
export class RegulaminComponent {

}
